import React from 'react';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { site } from '../data/content';
export function Header() {
  return <header className="sticky top-0 z-40 w-full border-b border-white/10 bg-forest-900/95 backdrop-blur" data-id="element-80" data-mp="2dmwcrok41qpa">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-5 py-3 lg:px-8" data-id="element-81" data-mp="2ik5z2vc7dm8w">
        <a href="#top" className="flex items-center gap-2.5" data-id="element-82" data-mp="2nlby1awgi5qv">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-gold-500 font-display text-sm font-extrabold text-forest-900" data-id="element-83" data-mp="2rmp15d85zuu3">
            FT
          </span>
          <span className="font-display text-base font-extrabold text-cream-50" data-id="element-84" data-mp="31byu0vau1hj9">
            {site.brand}
          </span>
        </a>

        <div className="ml-auto hidden items-center gap-6 text-xs font-medium text-cream-200 md:flex" data-id="element-85" data-mp="36bbghexskmlb">
          <span className="flex items-center gap-1.5" data-id="element-86" data-mp="3bb66zhdnna5u">
            <ShieldCheckIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-87" data-mp="3b8bohve7bzf2" />
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-88" data-mp="2wldy3sxznbbv">
            <LockIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-89" data-mp="2wirpdpzd2ps2" />
            Pago seguro
          </span>
        </div>

        <a href="#comprar" className="ml-auto shrink-0 rounded-md bg-gold-500 px-4 py-2.5 font-display text-xs font-extrabold uppercase tracking-wide text-forest-900 transition-colors duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-400 md:ml-8" data-id="element-90" data-mp="2mmeu4no643v7">
          Quiero el sistema
        </a>
      </div>
    </header>;
}